import {Component, ViewEncapsulation} from '@angular/core';
import {AppComponent} from "../../app.component";

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./error.component.less']
})
export class ErrorComponent {
  global_texts: any = null;

  constructor(
    public app: AppComponent
  ) {
  }

  ngOnInit() {
    this.app.sharedHelper.getGlobalTexts().subscribe((texts: object) => {
      this.global_texts = texts;
    });
  }
}
